<template>
  <div class="table-responsive">
    <el-table
      ref="table"
      :data="orders"
      header-row-class-name="thead-light"
      row-key="id"
      @selection-change="handleSelect"
    >
      <el-table-column type="expand">
        <template #default="{ row }">
          <ul class="list-group list-group-flush list my--3">
            <li v-for="item in row.items" :key="item.id" class="list-group-item px-0">
              <div class="align-items-center">
                <div class="row">
                  <div class="col-md-1 col-sm-12">
                    {{ item.article.code }}
                  </div>
                  <div class="col-md-3 col-sm-12">
                    <span class="font-weight-bold">{{ item.quantity }}</span
                    >&nbsp;x&nbsp;
                    <span>{{ item.article.description }}</span>
                  </div>
                  <div class="col-md-2 col-sm-12">{{ item.price | toCurrencyUSD }} .- c/u</div>
                  <div class="col-md-2 col-sm-12">
                    {{ (item.price * item.quantity) | toCurrencyUSD }}
                  </div>
                </div>
              </div>
            </li>

            <li v-if="row.items.length" class="list-group-item px-0">
              <div class="row">
                <div class="col-md-1 offset-md-5 col-sm-1 offset-sm-1">
                  <span class="font-weight-bold">Total</span>
                </div>
                <div class="col-md-2 col-sm-10">
                  <span>{{ total(row.items) | toCurrencyUSD }}</span>
                </div>
              </div>
            </li>

            <li v-if="!row.items.length" class="list-group-item px-0">Sin artículos.</li>
          </ul>
        </template>
      </el-table-column>

      <el-table-column type="selection" min-width="20" prop="id"> </el-table-column>

      <el-table-column label="Codigo" min-width="80px">
        <template #default="{ row }">
          <router-link :to="{ name: 'OrderShow', params: { id: row.id } }">
            {{ row.code }}
          </router-link>
        </template>
      </el-table-column>

      <el-table-column label="Productor" min-width="100x">
        <template #default="{ row }">
          <router-link v-if="$can('show', 'producers')" :to="{ name: 'ProducerShow', params: { id: row.producer.id } }">
            {{ row.producer.businessName }}
          </router-link>
          <span v-else>{{ row.producer.businessName }}</span>
          <div>
            <small>{{ row.producer.distributor.name }}</small>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="Mes de Compra">
        <template #default="{ row }">
          <span>{{ row.date | date('M') }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';

export default {
  name: 'GeneratePreviewTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },

  props: {
    orders: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      selection: [],
    };
  },

  mounted() {
    this.selectAll();
  },

  methods: {
    total(items) {
      return items.reduce((acc, i) => (acc += i.quantity * i.price), 0);
    },

    getSelectedItems() {
      return this.selection.map((item) => item.id);
    },

    handleSelect(values) {
      this.selection = values;
    },

    selectAll() {
      this.toggleSelection([...this.orders]);
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.table.toggleRowSelection(row);
        });
      } else {
        this.$refs.table.clearSelection();
      }
    },
  },
};
</script>

<style scoped>
::v-deep .el-table tr td {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

::v-deep .el-table .el-table__header-wrapper thead th {
  padding: 0.5rem 0.75rem;
}
</style>
